import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export const useCompanyPremiumStatus = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['company-premium-status', user?.id],
    queryFn: async () => {
      if (!user?.id) return false;
      
      const { data, error } = await supabase
        .from('companies')
        .select('is_premium')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching premium status:', error);
        return false;
      }
      
      return data?.is_premium ?? false;
    },
    enabled: !!user?.id
  });
};
